import { useHandleEscapeKey } from 'hooks'
import { Box } from 'theme-ui'
import { Heading } from 'components'
import { Label } from 'components/Form'
import { TMATTEnrollInput } from 'components/Form/TMATTEnrollInput'
import { TMATTCourseOptions } from 'types'

export const TMATTEnrollModal = ({
  name,
  set,
  cancel,
}: {
  name: string
  set: (course: TMATTCourseOptions) => void
  cancel: () => void
}) => {
  useHandleEscapeKey(cancel)

  return (
    <div style={{ textAlign: 'justify', lineHeight: 1.6 }}>
      <Heading variant="forms.h1" sx={{ textAlign: 'left', mb: 20 }}>
        Enroll teacher to course
      </Heading>
      <Label sx={{ fontWeight: 600 }}>Course options:</Label>
      <Box sx={{}}>
        <TMATTEnrollInput
          name={name}
          onChange={set}
          options={courseOptions}
          placeholder={`Please select a course to enroll the teacher to`}
        />
      </Box>
    </div>
  )
}

const courseOptions: TMATTCourseOptions[] = [
  {
    course: 'tmatt',
    label: 'TMATT',
  },
  {
    course: 'tmatt-refresher',
    label: 'TMATT Refresher',
  },
]
